// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d8e848ac","172":"d96a73a3","203":"64b34c36","372":"7cc3bbd3","407":"3cd3f0e2","464":"66496711","483":"dfb62716"}[chunkId] + ".chunk.js";
};